/**
 * Which tests a testing day is made of.
 *
 * One function, because three places need the answer and three answers is how
 * this broke: the grid inferred the list from whichever results happened to
 * exist, the results report did the same, and the blank sheet did not ask at
 * all and printed every test the club has ever defined — twenty columns for a
 * day of five.
 *
 * In order of what it actually knows:
 *
 *  1. `testKeys` — the coach chose these. Stored on the day itself.
 *  2. The keys that have results — a day recorded before the choice was stored.
 *  3. The first five physical tests — what a pre-season testing day almost
 *     always is, and the only honest guess for a day with nothing on it yet.
 *
 * Always in catalogue order, never in the order they were tapped, so the same
 * day prints its columns the same way twice.
 */
export const DEFAULT_TEST_COUNT = 5;

export function resolveBatteryTests<T extends { key: string; dimension?: string }>(
  testKeys: readonly string[] | null | undefined,
  catalogue: readonly T[],
  results: readonly { testKey: string }[] = [],
): T[] {
  if (testKeys) {
    const chosen = new Set(testKeys);
    // Filtered through the catalogue rather than mapped from the stored list:
    // a test the club retired after the day was planned should leave the sheet,
    // not head an empty column.
    return catalogue.filter((x) => chosen.has(x.key));
  }

  const recorded = new Set(results.map((r) => r.testKey));
  const used = catalogue.filter((x) => recorded.has(x.key));
  if (used.length > 0) return used;

  return catalogue.filter((x) => x.dimension === 'physical').slice(0, DEFAULT_TEST_COUNT);
}
